import { render, staticRenderFns } from "./NuevoRegistro.vue?vue&type=template&id=7ceed5c7&"
import script from "./NuevoRegistro.vue?vue&type=script&lang=js&"
export * from "./NuevoRegistro.vue?vue&type=script&lang=js&"
import style0 from "./NuevoRegistro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports